import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-manage-profile',
  templateUrl: './manage-profile.component.html',
  styleUrl: './manage-profile.component.css'
})
export class ManageProfileComponent {
  profileAction: string = "";
  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.profileAction = params['action'] == 'view-profile' ? 'view' : 'edit';
    });
  }
}
